import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie } from 'utils/functions-cookie'

type RewardBody = {
  email: string
  reward: number
  newEmployee: boolean
  name?: string
  price?: number
}

export const createReward = async (body: RewardBody[]) => {
  const authToken = getCookie('auth_token')

  if (!authToken) {
    throw new Error('Você não está autenticado.')
  }

  const response = await fetch(`${BASE_URL_API}/rewards`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('Sessão expirada')
    }
    throw new Error('Erro ao criar recompensa')
  }
}
